import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import FieldTechniciansEditContent from "../../../components/Pages/FieldTechnicians/Edit";

const { displayName } = config;

export default function FieldTechniciansEdit(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Edit Field Technicians`;
  }, []);

  return (
    <Layout>
      <FieldTechniciansEditContent />
    </Layout>
  );
}
